// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Direct messages page. Root: .chat-page. Desktop: list + conversation side by side.
   Phones/tablets (.chat-page--compact): one pane at a time, edge to edge. */
.chat-page {
  display: flex;
  min-height: 420px;
  /* Fill the content area: the /chats page has no page header. */
  height: calc(
    100vh - var(--ds-topbar-h) - var(--ds-safe-top) - 2 * var(--ds-page-pad) - var(--ds-safe-bottom)
  );
  height: calc(
    100dvh - var(--ds-topbar-h) - var(--ds-safe-top) - 2 * var(--ds-page-pad) -
      var(--ds-safe-bottom)
  );
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.05);
}

.chat-page__main {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  background: #ffffff;
}

.chat-page__bar {
  display: flex;
  align-items: center;
  min-height: 56px;
  padding: 8px 16px;
  border-bottom: 1px solid #eef2f6;
}

.chat-page__empty {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
  text-align: center;
  background: radial-gradient(circle at 50% 30%, #ffffff 0%, #f4f7f9 100%);
}

.chat-page__empty-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 360px;
}

.chat-page__empty-icon {
  width: 72px;
  height: 72px;
  border-radius: 24px;
  background: linear-gradient(135deg, #ecf7fb 0%, #d5eef6 100%);
  color: #157f9f;
  font-size: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  box-shadow: 0 4px 16px rgba(21, 127, 159, 0.15);
}

.chat-page__empty-title {
  font-size: 1.125rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 8px;
}

.chat-page__empty-subtitle {
  font-size: 0.875rem;
  color: #64748b;
  line-height: 1.5;
  margin: 0;
}

[dir="rtl"] .chat-page .chat-page__back-icon {
  transform: scaleX(-1);
}

/* Phones/tablets: cancel the content padding so the chat runs edge to edge, like a
   messaging app; the composer then pads itself above the home indicator. */
.chat-page--compact {
  min-height: 0;
  margin: calc(-1 * var(--ds-page-pad));
  margin-bottom: calc(-1 * (var(--ds-page-pad) + var(--ds-safe-bottom)));
  height: calc(100vh - var(--ds-topbar-h) - var(--ds-safe-top));
  height: calc(100dvh - var(--ds-topbar-h) - var(--ds-safe-top));
  border: 0;
  border-radius: 0;
  box-shadow: none;
  --chat-composer-bottom: var(--ds-safe-bottom);
}

/* With the bottom navigation bar the chat ends above it (the bar owns the safe area). */
.app-shell--with-bottomnav .chat-page--compact {
  margin-bottom: calc(-1 * (var(--ds-bottomnav-h) + var(--ds-safe-bottom) + var(--ds-space-4)));
  height: calc(
    100vh - var(--ds-topbar-h) - var(--ds-safe-top) - var(--ds-bottomnav-h) - var(--ds-safe-bottom)
  );
  height: calc(
    100dvh - var(--ds-topbar-h) - var(--ds-safe-top) - var(--ds-bottomnav-h) - var(--ds-safe-bottom)
  );
  --chat-composer-bottom: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/commons/Chats/Chat.css"],"names":[],"mappings":"AAAA;4EAC4E;AAC5E;EACE,aAAa;EACb,iBAAiB;EACjB,+DAA+D;EAC/D;;GAEC;EACD;;;GAGC;EACD,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,OAAO;EACP,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,wEAAwE;AAC1E;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;2EAC2E;AAC3E;EACE,aAAa;EACb,qCAAqC;EACrC,sEAAsE;EACtE,6DAA6D;EAC7D,8DAA8D;EAC9D,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA,wFAAwF;AACxF;EACE,6FAA6F;EAC7F;;GAEC;EACD;;GAEC;EACD,2BAA2B;AAC7B","sourcesContent":["/* Direct messages page. Root: .chat-page. Desktop: list + conversation side by side.\n   Phones/tablets (.chat-page--compact): one pane at a time, edge to edge. */\n.chat-page {\n  display: flex;\n  min-height: 420px;\n  /* Fill the content area: the /chats page has no page header. */\n  height: calc(\n    100vh - var(--ds-topbar-h) - var(--ds-safe-top) - 2 * var(--ds-page-pad) - var(--ds-safe-bottom)\n  );\n  height: calc(\n    100dvh - var(--ds-topbar-h) - var(--ds-safe-top) - 2 * var(--ds-page-pad) -\n      var(--ds-safe-bottom)\n  );\n  overflow: hidden;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.05);\n}\n\n.chat-page__main {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n  background: #ffffff;\n}\n\n.chat-page__bar {\n  display: flex;\n  align-items: center;\n  min-height: 56px;\n  padding: 8px 16px;\n  border-bottom: 1px solid #eef2f6;\n}\n\n.chat-page__empty {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: center;\n  padding: 32px 24px;\n  text-align: center;\n  background: radial-gradient(circle at 50% 30%, #ffffff 0%, #f4f7f9 100%);\n}\n\n.chat-page__empty-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: 360px;\n}\n\n.chat-page__empty-icon {\n  width: 72px;\n  height: 72px;\n  border-radius: 24px;\n  background: linear-gradient(135deg, #ecf7fb 0%, #d5eef6 100%);\n  color: #157f9f;\n  font-size: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 20px;\n  box-shadow: 0 4px 16px rgba(21, 127, 159, 0.15);\n}\n\n.chat-page__empty-title {\n  font-size: 1.125rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin-bottom: 8px;\n}\n\n.chat-page__empty-subtitle {\n  font-size: 0.875rem;\n  color: #64748b;\n  line-height: 1.5;\n  margin: 0;\n}\n\n[dir=\"rtl\"] .chat-page .chat-page__back-icon {\n  transform: scaleX(-1);\n}\n\n/* Phones/tablets: cancel the content padding so the chat runs edge to edge, like a\n   messaging app; the composer then pads itself above the home indicator. */\n.chat-page--compact {\n  min-height: 0;\n  margin: calc(-1 * var(--ds-page-pad));\n  margin-bottom: calc(-1 * (var(--ds-page-pad) + var(--ds-safe-bottom)));\n  height: calc(100vh - var(--ds-topbar-h) - var(--ds-safe-top));\n  height: calc(100dvh - var(--ds-topbar-h) - var(--ds-safe-top));\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n  --chat-composer-bottom: var(--ds-safe-bottom);\n}\n\n/* With the bottom navigation bar the chat ends above it (the bar owns the safe area). */\n.app-shell--with-bottomnav .chat-page--compact {\n  margin-bottom: calc(-1 * (var(--ds-bottomnav-h) + var(--ds-safe-bottom) + var(--ds-space-4)));\n  height: calc(\n    100vh - var(--ds-topbar-h) - var(--ds-safe-top) - var(--ds-bottomnav-h) - var(--ds-safe-bottom)\n  );\n  height: calc(\n    100dvh - var(--ds-topbar-h) - var(--ds-safe-top) - var(--ds-bottomnav-h) - var(--ds-safe-bottom)\n  );\n  --chat-composer-bottom: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
